declare global {
    interface Window {
        __IAM_CONFIG__?: {
            iamBase?: string
            authBase?: string
            oauthBase?: string
            // UI defaults: applied only on the user's first visit (before
            // they pick a theme/brand from the toggles). Per-user choices
            // are persisted in localStorage and override these.
            defaultTheme?: 'dark' | 'light' | 'system'
            defaultBrandTheme?: string
            brandMode?: 'builtin' | 'tenant'
            brandName?: string
        }
    }
}

const DEFAULT_IAM_BASE = '/api/i'
const DEFAULT_AUTH_BASE = '/api/auth'
const DEFAULT_OAUTH_BASE = ''
const DEFAULT_BRAND_MODE: 'builtin' | 'tenant' = 'builtin'

function readWindowConfig(): Window['__IAM_CONFIG__'] | undefined {
    return typeof window !== 'undefined' ? window.__IAM_CONFIG__ : undefined
}

export function iamBase(path: string): string {
    const base = readWindowConfig()?.iamBase ?? DEFAULT_IAM_BASE
    return base + path
}

export function authBase(path: string): string {
    const base = readWindowConfig()?.authBase ?? DEFAULT_AUTH_BASE
    return base + path
}

export function oauthBase(path: string): string {
    const base = readWindowConfig()?.oauthBase ?? DEFAULT_OAUTH_BASE
    return base + path
}

export function configuredDefaultTheme(): 'dark' | 'light' | 'system' | undefined {
    return readWindowConfig()?.defaultTheme
}

export function configuredDefaultBrandTheme(): string | undefined {
    return readWindowConfig()?.defaultBrandTheme
}

export function brandMode(): 'builtin' | 'tenant' {
    const raw = readWindowConfig()?.brandMode
    return raw === 'tenant' ? 'tenant' : DEFAULT_BRAND_MODE
}

export function brandName(): string | undefined {
    return readWindowConfig()?.brandName
}

export function isTenantMode(): boolean {
    return brandMode() === 'tenant'
}
